var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticStyle:{"height":"500px"}},[(_vm.showEpub)?_c('iframe',{attrs:{"id":"epubFrame","src":_vm.EpubURL,"frameborder":"0"}},[_vm._v(" Your browser doesn't support iframes ")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }